var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuasela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 438 398",
    style: {
      enableBackground: "new 0 0 438 398"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5757FF;}\r\n\t.st1{opacity:0.15;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#474747;}\r\n\t.st4{fill:#FAFAFA;}\r\n\t.st5{opacity:0.1;enable-background:new    ;}\r\n\t.st6{fill:#343434;}\r\n\t.st7{opacity:0.34;}\r\n\t.st8{fill:#EBEBEB;}\r\n\t.st9{fill:#455A64;}\r\n\t.st10{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st11{opacity:0.65;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st12{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st13{fill:#F28F8F;}\r\n\t.st14{opacity:0.5;enable-background:new    ;}\r\n\t.st15{fill:#37474F;}\r\n\t.st16{fill:#263238;}\r\n\t.st17{opacity:0.35;enable-background:new    ;}\r\n\t.st18{opacity:0.2;enable-background:new    ;}\r\n\t.st19{fill:#B16668;}\r\n\t.st20{opacity:0.3;enable-background:new    ;}\r\n\t.st21{fill:#F0F0F0;}\r\n\t.st22{fill:#9A4A4D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Track_and_field-amico",
    transform: "translate(-13.47 -42.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-209",
    transform: "translate(318.819 153.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_307",
    className: "st0",
    d: "M54.5,95.3l-5.9-3.4c0,0-3.5-14.7-2.1-28c2-18.6,14.3-25.7,18.9-24s6,7-1.7,18.1 C59,64.5,53.4,78.1,54.5,95.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_308",
    d: "M54.5,95.3l-5.9-3.4c0,0-3.5-14.7-2.1-28c2-18.6,14.3-25.7,18.9-24s6,7-1.7,18.1 C59,64.5,53.4,78.1,54.5,95.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_309",
    className: "st2",
    d: "M52,88L52,88c0.3,0,0.4-0.3,0.4-0.5C49.1,70.3,55.1,51,62.6,43c0.1-0.2,0.1-0.4-0.1-0.6 c-0.2-0.1-0.4-0.1-0.5,0c-7.6,8.2-13.7,27.8-10.4,45.2C51.6,87.9,51.8,88,52,88L52,88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_310",
    className: "st0",
    d: "M70.1,104.3c0.9,0.5,3.4-1.7,4.1-2.2c1.2-0.9,2.1-2.1,2.7-3.5c0.7-1.6,0.8-3.3,0.5-4.9 c-0.2-0.9-0.4-1.7-0.7-2.6c-0.3-0.8-0.6-1.7-0.9-2.5c-0.3-0.8-0.5-1.7-0.5-2.5c0.1-1.8,1.6-3,3-4.2c1.5-1.2,3-2.8,2.9-4.9 c-0.2-1.6-0.9-3.1-2.1-4.3c-1.1-1.2-2.3-2.3-3.3-3.6c-0.8-0.9-1.2-2-1.2-3.2c0.1-0.7,0.3-1.4,0.6-2.1c0.8-1.3,1.5-2.7,2-4.2 c0.5-1.5,0.2-3.2-0.9-4.3c-1.1-0.7-2.4-1-3.6-0.7c-1.2,0.2-2.3,0.7-3.3,1.4c-3.2,2-4.9,6-8.4,7.6c-1.4,0.5-2.8,0.9-4.2,1.3 c-1.4,0.3-2.7,1.3-3.4,2.6c-1.2,2.6,1.4,5.7,0.6,8.5c-0.7,2.5-3,3.5-4.2,5.8c-0.5,1-0.7,2.1-0.5,3.2c0.2,1.8,0.8,3.6,1.6,5.3 c1,1.7,2,3.3,3.2,4.9C54.2,95.1,69.9,104.2,70.1,104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_311",
    className: "st2",
    d: "M60.9,99.5L60.9,99.5c0.2,0,0.4-0.2,0.4-0.5C59.8,82.7,66.6,64.2,72,58.7 c0.1-0.2,0.1-0.4-0.1-0.6c-0.2-0.1-0.4-0.1-0.5,0c-5.5,5.7-12.4,24.4-10.9,41C60.5,99.4,60.7,99.5,60.9,99.5 C60.9,99.5,60.9,99.5,60.9,99.5L60.9,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_312",
    className: "st2",
    d: "M62.6,79.4h0.1c3.8-1.3,7.8-2.1,11.8-2.5c0.2,0,0.4-0.2,0.4-0.5c0-0.2-0.2-0.4-0.4-0.4 c0,0,0,0,0,0c-4.1,0.4-8.1,1.3-12,2.6c-0.2,0.1-0.3,0.3-0.3,0.5c0,0,0,0,0,0C62.2,79.3,62.4,79.4,62.6,79.4L62.6,79.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-209",
    transform: "translate(13.47 164.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Track--inject-209"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-209-2",
    className: "st3",
    cx: 221.1,
    cy: 140.6,
    rx: 175.1,
    ry: 101.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_313",
    className: "st4",
    d: "M395.6,132.7L234.8,39.9c-4.1-0.2-8.3-0.3-12.4-0.3l173.7,100.3 C396.1,137.5,396,135.1,395.6,132.7L395.6,132.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_314",
    className: "st4",
    d: "M95.1,70.5c-1.9,1.2-3.8,2.4-5.7,3.6l247,142.6c2.1-1.1,4.2-2.2,6.2-3.3L95.1,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_315",
    className: "st4",
    d: "M50.3,162.8l132.4,76.4c4.8,0.6,9.6,1.1,14.5,1.5L47.7,154.5 C48.4,157.3,49.3,160.1,50.3,162.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-209",
    transform: "translate(105.909 214.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-209-2",
    className: "st5",
    d: "M145.1,100.8l4.9,2.9l82.9-47.9L228,53L145.1,100.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-209-3",
    className: "st6",
    cx: 163.6,
    cy: 56.5,
    rx: 29.4,
    ry: 17
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-209-4",
    className: "st6",
    cx: 75.4,
    cy: 102.5,
    rx: 29.4,
    ry: 17
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-209-5",
    className: "st5",
    d: "M54,153.1l4.9,2.9l82.9-47.9l-4.9-2.9L54,153.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-209",
    transform: "translate(13.47 6.538)",
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-209-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_316",
    className: "st8",
    d: "M132.1,83.6L117.4,92c0.1-0.6,0.1-1.3,0.1-1.9v-4.3c0-7.6-5.3-10.6-11.9-6.9 c-2.8,1.8-5.2,4.1-7.1,6.9c-1.1-9.5-8.5-13-17.6-7.8c-9.8,5.7-17.7,19.4-17.7,30.7v6.4c0,2.5,0.5,5,1.5,7.3l-12.2,7.1 c-3.9,2.5-6.3,6.8-6.6,11.4c0,4.2,2.9,5.9,6.6,3.8l79.4-45.8c3.9-2.5,6.3-6.8,6.6-11.4C138.6,83.2,135.7,81.5,132.1,83.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_317",
    className: "st8",
    d: "M222.8,90.2l-11.1,6.4c0-0.5,0-1,0-1.5V92c0-5.7-4-8-8.9-5.2c-2.1,1.3-3.9,3.1-5.3,5.1 c-0.8-7.2-6.4-9.8-13.3-5.9c-7.9,5.2-12.9,13.8-13.4,23.2v4.8c0,1.9,0.3,3.8,1.1,5.6l-9.2,5.3c-2.9,1.9-4.7,5.1-4.9,8.6 c0,3.2,2.2,4.5,5,2.9l60-34.5c2.9-1.9,4.8-5.1,5-8.6C227.8,89.9,225.5,88.7,222.8,90.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hurdle-2--inject-209",
    transform: "translate(189.968 155.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fence--inject-209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_318",
    className: "st9",
    d: "M68.8,96v56.6c0,0.2-0.2,0.4-0.4,0.4c-0.1,0-0.1,0-0.2-0.1L49,141.8l-2.5,4.3l22.5,13 c1.5,0.9,3.4,0.4,4.3-1.1c0.3-0.5,0.4-1,0.4-1.6V98.8L68.8,96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_319",
    className: "st9",
    d: "M47.8,142c1-0.6,1.7-0.1,1.7,1c-0.1,1.2-0.7,2.3-1.7,3c-1,0.6-1.8,0.1-1.8-1 C46.1,143.8,46.8,142.6,47.8,142z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_320",
    className: "st9",
    d: "M136.9,56.7v56.6c0,0.2-0.2,0.4-0.4,0.4c-0.1,0-0.1,0-0.2-0.1l-19.2-11.1l-2.4,4.3l22.4,13 c1.5,0.9,3.4,0.3,4.3-1.2c0.3-0.5,0.4-1,0.4-1.6V59.5L136.9,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_321",
    className: "st9",
    d: "M115.9,102.7c1-0.6,1.7-0.1,1.7,1c-0.1,1.2-0.7,2.4-1.7,3c-1,0.6-1.7,0.1-1.7-1 C114.2,104.5,114.9,103.3,115.9,102.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_322",
    className: "st0",
    d: "M58.9,87.4l82.9-47.9l4.9,2.9v17.1l-82.9,47.9l-4.9-2.8V87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_323",
    className: "st10",
    d: "M58.9,87.4l4.9,2.9l82.9-47.9l-4.9-2.9L58.9,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_324",
    className: "st11",
    d: "M63.9,90.3l82.9-47.9v17.1l-82.9,47.9V90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_325",
    className: "st12",
    d: "M58.9,87.4l4.9,2.9v17.1l-4.9-2.8V87.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-209",
    transform: "translate(181.355 62.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_326",
    className: "st13",
    d: "M99.6,71.4c0,0,4.2-0.7,6.5,2.4s1.9,7.6,1,11.7S99.6,71.4,99.6,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_327",
    className: "st0",
    d: "M114.7,123.3c3.6-2.7,7-1.3,7.6,3.1c0.4,4.9-1.6,9.8-5.3,13c-3.6,2.7-7,1.3-7.6-3.1 C109,131.3,111,126.5,114.7,123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_328",
    className: "st14",
    d: "M114.7,123.3c3.6-2.7,7-1.3,7.6,3.1c0.4,4.9-1.6,9.8-5.3,13c-3.6,2.7-7,1.3-7.6-3.1 C109,131.3,111,126.5,114.7,123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_329",
    className: "st13",
    d: "M101.4,110.1c0,0,22.6,14.3,27.3,18.3c3.5,3.1,4.1,4.5,11.2,15.7 c6.1,9.6,16.6,26.4,16.6,26.4c-0.4,2.5-2.1,4.7-4.5,5.6c0,0-15-14.1-20.5-19.9s-8.3-14.4-8.3-14.4l-31.1-9.3l1.1-9L101.4,110.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_330",
    className: "st0",
    d: "M167.2,158.1c-2.6,0.1-4.1,2.2-5.3,4.1s-3.1,5.2-3.9,5.8s-1.4,0-2.6,0.9s-2.1,2.6-1.7,3.3 l0.9,1.5c-1-0.1-2.1,0.3-2.8,1c-1.3,1.3-0.6,1.6,0.1,2.3s2.1,3.6,3.8,4.5c3.4-1.3,6.3-3.7,8.2-6.8 C167.5,169.5,167.2,158.1,167.2,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_331",
    className: "st15",
    d: "M156.8,182.4c-0.7-0.1-1.2-0.8-1.1-1.5c0-0.1,0-0.1,0-0.2c0.5-1.7,1.3-3.2,2.3-4.6 c1.2-1.7,3.4-4.9,3.8-6.6s1.2-6.6,2.5-8.7s2.7-3.2,4.5-2.6s-3.8,13.8-5.4,16S156.8,182.4,156.8,182.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_332",
    className: "st16",
    d: "M157.8,182.1c4.4-2.3,5.8-4.6,7.1-7.5s4.3-5.7,5.1-8.3s0.9-9.4-2.1-7.8s-3.6,7.7-4.9,11.2 S153.6,184.4,157.8,182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_333",
    className: "st0",
    d: "M120,122.1l-14.4-10.1l-28.2-0.5c0,0,1.9,16.2,9.5,19.5c9.1,4,24.7,9.2,24.7,9.2 c-3.6-3-2.6-8.9-0.4-12.8C114.7,121.6,117.5,121.5,120,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_334",
    className: "st17",
    d: "M120,122.1l-14.4-10.1l-28.2-0.5c0,0,1.9,16.2,9.5,19.5c9.1,4,24.7,9.2,24.7,9.2 c-3.6-3-2.6-8.9-0.4-12.8C114.7,121.6,117.5,121.5,120,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_335",
    className: "st18",
    d: "M96.1,126.7c4.1-2.1,7.4-5.4,9.5-9.5c-1,4.5-3.9,8.4-8,10.5l-0.5,6l13.3,6.2 c-5.1-1.7-10.4-3.6-15.9-5.7L96.1,126.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_336",
    className: "st15",
    d: "M65.1,125.8c-0.4-0.8-1-1.6-1.8-2c-1.7-0.6-3.6-0.2-4.9,1.1c-1.6,1.7-2.6,4-3.6,5.3 c-1.6,1.5-3.4,2.9-5.3,4c-2.1,1.6-3.4,4.1-3.4,6.8c0.1,1.6,1.1,3.1,2.6,3.8L65.1,125.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_337",
    className: "st0",
    d: "M64.5,125c-1.7-0.7-3.6-0.4-5,0.8c-1.4,1.1-2.5,3.2-3.5,4.7c-0.6,0.7-1.2,1.4-2,1.9 c-0.8,0.7-3,2-3.7,2.8c-0.6,0.6-1.1,1.4-1.6,2.1c-0.5,0.8-0.8,1.8-1,2.7c-0.2,1.5,0,3.7,1,4.8c1,1.2,2.7,1.3,3.9,0.3 c0.2-0.1,0.3-0.3,0.4-0.4c0.4-0.5,0.8-1,1.2-1.5c0.7-1,1.5-1.8,2.4-2.6c1.2-1,2.5-1.8,3.8-2.5c0.1-0.1,0.3-0.2,0.5-0.2 c1.7-0.6,3.3-1.2,3.6-1.7s1.1-5.6,2.4-6.5c0.4-0.3,0.2-0.7-0.1-1.2S65.6,125.7,64.5,125z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_338",
    className: "st13",
    d: "M78.1,109.1c-1.7,6.2-2.9,12.5-3.4,18.9c-0.3,5.4-0.5,18.1-0.5,24.4s-0.3,10.8,1.9,13 s6.7,1.8,8.8-2.1s3.4-8.2,5.2-15.6S93,135,93,135l2.4-20.2L78.1,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_339",
    className: "st13",
    d: "M79.3,166.6c-2.7,0-4.5-1.1-7.9-7.7s-10.6-24-10.6-24s-0.9-3.3,1.5-5.3 c2.7-2.3,4.2-0.8,4.2-0.8s1.9,2.9,4.1,5.7c2,2.6,4.6,5.1,6.3,7.5C78.1,143.7,79.3,166.6,79.3,166.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_340",
    className: "st19",
    d: "M74.3,138.8c0,0-0.4,15.3-0.1,20.8c-0.9-3.7-1.4-7.6-1.5-11.4c-0.2-3.7-0.2-7.4,0.1-11.1 L74.3,138.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_341",
    className: "st0",
    d: "M78.1,109.1c-1.5,4.1-2.6,8.4-3.3,12.8c-0.9,6.9-0.7,21.9-0.7,21.9s1.9,3.3,8.2,4.5 s9.5-2,9.5-2l4.3-19.6c0,0,8.8-4.2,11-13.6L78.1,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_342",
    className: "st20",
    d: "M78.1,109.1c-1.5,4.1-2.6,8.4-3.3,12.8c-0.9,6.9-0.7,21.9-0.7,21.9s1.9,3.3,8.2,4.5 s9.5-2,9.5-2l4.3-19.6c0,0,8.8-4.2,11-13.6L78.1,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_343",
    className: "st16",
    d: "M93.8,58.7l-2.6,9c-7.4,0-11.9-7.2-11.9-14.5l0,0c0-7.4,4.7-13.6,12.1-13.6h2.4 c7.4,0,13.3,4.9,13.3,12.3l0,0C107.1,56.7,101.1,58.7,93.8,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_344",
    className: "st15",
    d: "M86.9,71.2h-1.4c-6.5,0.4-6.9,2.7-7.2,5.6c-0.6,3.1-0.5,6.2,0.2,9.3 c1,4,1.3,13.6,1.3,13.6s-1.9,8.3-2.8,12.5c11.4,7.4,25.4,5.5,30.1,1c-0.1-4,0.1-8.4-0.2-12.2c0,0,0.2-6.4,0.6-9 c3.1-3.9,2.8-6.9,1.5-10.1c-2.3-5.6-8-10.4-9.4-10.4L86.9,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_345",
    className: "st13",
    d: "M102.3,45.5c1.5,0.9,3.4,4.8,3.3,12.9c-0.2,6.9-2.4,8.6-3.5,9.1s-3.3,0.2-5.4-0.2v4.1 c0,0,2.9,3.4,2.7,5.3s-4.2,2.3-6.9,0.5c-1.9-1.5-3.4-3.4-4.5-5.5v-8.9c0,0-1.4,1.7-3.7,0.1s-2.4-5.3-1.1-6.7s4.3-0.9,4.8,1 c2.8-0.1,5.4-0.9,7.8-2.3C99.4,52.9,101.8,49.4,102.3,45.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_346",
    className: "st16",
    d: "M97.1,56.6c0,0.5-0.3,0.9-0.8,0.9c0,0,0,0,0,0c-0.5,0-0.9-0.3-1-0.8c0-0.5,0.3-0.9,0.8-1 C96.6,55.7,97.1,56.1,97.1,56.6C97.1,56.6,97.1,56.6,97.1,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_347",
    className: "st19",
    d: "M98.1,62.5l2,0.6c-0.1,0.6-0.7,0.9-1.2,0.8c0,0,0,0-0.1,0C98.2,63.7,97.9,63.1,98.1,62.5 L98.1,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_348",
    className: "st16",
    d: "M104.2,54l-1.8-1.2c0.3-0.5,0.9-0.6,1.4-0.4c0,0,0.1,0,0.1,0.1 C104.4,52.8,104.5,53.5,104.2,54L104.2,54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_349",
    className: "st16",
    d: "M103.8,56c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9c0-0.5,0.4-0.8,0.8-0.9 C103.4,55.1,103.8,55.5,103.8,56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_350",
    className: "st19",
    d: "M99.6,55.5l0.1,5.2l2.7-0.8L99.6,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_351",
    className: "st19",
    d: "M96.7,67.3c-2.2-0.3-6.8-1.6-7.5-3.4c0.3,0.9,0.8,1.7,1.6,2.3c1.4,1.2,5.9,2.5,5.9,2.5 V67.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_352",
    className: "st16",
    d: "M71.5,44.7c-2.8,2.6-6.5,3.8-10.2,3.5c-2.3-0.2-4.9-0.8-6.7,0.6c-1.4,1.2-1.8,3.2-0.8,4.8 c0.9,1.8,3.2,3,5.1,3.7c2.3,0.9,4.8,1,7.2,0.4c2.3-0.6,4.4-1.8,6.1-3.4c1.2-1.3,2.3-2.8,3.3-4.3c1-1.5,2.3-2.8,3.9-3.6 c0.9-0.4,1.8-0.7,2.8-0.9c1-0.3,2.1-0.9,2.2-1.9c0-0.8-0.5-1.5-1.2-1.9c-1.5-0.9-3.2-1.1-4.8-0.7C75.8,41.7,73.5,43,71.5,44.7 L71.5,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_353",
    className: "st21",
    d: "M86.7,97.7c0,0,11.5,1,18.4-2.5l-0.3,11.5c-5.8,2.9-12.5,3.6-18.7,1.8L86.7,97.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_354",
    d: "M92.7,102.9v1.5c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.2,0.5-0.4,0.7c-0.2,0.2-0.5,0.4-0.7,0.4 c-0.3,0.1-0.7,0.1-1.1,0.1c-0.4,0-0.7-0.1-1-0.3c-0.3-0.1-0.5-0.3-0.7-0.5c-0.2-0.2-0.3-0.5-0.3-0.7c-0.1-0.3-0.1-0.6-0.1-0.9 v-0.7c0-0.2,0-0.5,0.1-0.7c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.5,0.4-0.7c0.2-0.2,0.5-0.4,0.7-0.4c0.3-0.1,0.7-0.1,1.1-0.1 c0.4,0,0.7,0.1,1,0.2c0.5,0.2,0.9,0.7,1,1.2C92.7,102.3,92.7,102.6,92.7,102.9L92.7,102.9z M89.2,104.2c0,0.3,0.1,0.7,0.2,1 c0.2,0.3,0.5,0.4,0.8,0.4c0.3,0.1,0.6,0,0.9-0.3c0.2-0.3,0.3-0.6,0.3-0.9c0-0.2,0-0.4,0.1-0.7s0-0.5,0-0.7c0-0.3-0.1-0.7-0.2-0.9 c-0.2-0.3-0.5-0.4-0.8-0.4c-0.3-0.1-0.6,0-0.9,0.3c-0.2,0.3-0.3,0.6-0.3,0.9c0,0.2,0,0.4-0.1,0.7S89.2,103.9,89.2,104.2 L89.2,104.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_355",
    d: "M102.4,101.5c0.1-0.1,0.3-0.3,0.3-0.5c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.4-0.2-0.5 c-0.2-0.1-0.5-0.2-0.7-0.1c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1l-0.7,0.1 c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.2c0-0.3,0.1-0.5,0.2-0.7c0.1-0.2,0.3-0.5,0.5-0.7c0.2-0.2,0.4-0.4,0.7-0.5 c0.3-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.6-0.1,0.9,0c0.5,0.1,0.8,0.4,1,0.9c0.1,0.2,0.1,0.4,0.1,0.6c0,0.1,0,0.3-0.1,0.4 c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.2-0.2,0.3-0.3,0.4c-0.2,0.2-0.3,0.4-0.5,0.5l-1.6,1.7c0.9-0.1,1.4-0.2,2.4-0.4c0.1,0,0.1,0,0.2,0 c0,0,0.1,0.1,0.1,0.1v0.6c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.2,0.1c-1.6,0.3-2.4,0.4-4,0.6c-0.1,0-0.1,0-0.2,0 c0,0-0.1-0.1-0.1-0.1v-0.5c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.2-0.2C100.8,103.1,101.3,102.6,102.4,101.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_356",
    d: "M98.3,99.8c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1l-0.1,0.6c0,0.1,0,0.1-0.1,0.2l-0.1,0.2 c-0.6,0.6-0.9,0.9-1.4,1.5c0.2,0,0.5,0,0.7,0.1c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.3,0.4c0,0.2,0,0.4,0,0.6 c0,0.3-0.1,0.6-0.3,0.8c-0.1,0.3-0.3,0.5-0.6,0.7c-0.2,0.2-0.5,0.4-0.8,0.5c-0.3,0.1-0.6,0.2-0.9,0.3c-0.3,0.1-0.7,0.1-1,0 c-0.2,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.2-0.1-0.3-0.1-0.5c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1l0.7-0.1 c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.4,0,0.5,0 c0.3,0,0.6-0.2,0.9-0.4c0.2-0.1,0.4-0.4,0.4-0.6c0.1-0.2-0.1-0.4-0.3-0.5c-0.3-0.1-0.6-0.1-0.8,0l-0.7,0.1c-0.1,0-0.1,0-0.2,0 c0,0-0.1-0.1-0.1-0.1l0.1-0.6c0-0.1,0-0.1,0.1-0.2l0.1-0.2c0.5-0.6,0.8-0.9,1.4-1.4c-0.9,0.2-1.4,0.2-2.4,0.4c-0.1,0-0.1,0-0.2,0 c0,0-0.1-0.1-0.1-0.1l0.1-0.6c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1C95.7,100.3,97,100.1,98.3,99.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_357",
    className: "st13",
    d: "M84.4,71.3c-5.1-0.1-7.6,1.3-9.5,6.6s-4.9,26.1-3.3,28.7s17.3,3.4,22.6,3.5 s11.9-1.4,15.8-3.6c3.8-2.1,6-7.3,4.2-9.7c-1.1-1.4-1.8-1.1-3-0.1c-1.6,1.3-3.4,2.2-5.4,2.5c0.6-0.7,1.1-1.5,1.5-2.3 c0.3-0.5,0.5-1.1,0.7-1.7c0.2-0.4,0.1-0.9-0.1-1.3c-0.4-0.4-1-0.4-1.4-0.1c-0.4,0.3-0.8,0.7-1,1.1c-0.6,0.6-1.2,1.2-2,1.7 l-3.5,2.5c-0.6,0.4-1.2,0.9-1.8,1.2c-1.6,0.8-3.4,1.1-5.2,1c-4-0.2-8.1-0.8-12-1.7l2.9-15.9C83.8,83.7,87.2,77,84.4,71.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-209",
    transform: "translate(70.583 111.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-209-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_358",
    className: "st19",
    d: "M124.3,76.4c-0.6-6.9-2.5-9.8-5.4-10.5c-4.6-1.1-5,0.7-3.4,4c0.7,1.4,1.2,2.9,1.5,4.4 c-0.5-0.6-1.1-1.1-1.7-1.6c-0.7-0.5-1.7-0.4-2.2,0.2c-0.2,0.3,0.6,0.7,1.3,2c0.9,1.6,1,2.8,2.3,4.2c0.5,0.7,0.8,1.6,0.9,2.5 c0,3.1-0.5,6.1-1.3,9.1c-2.4-3.4-5.1-6.9-7.1-9.6c-3.7-5-4.6-6.6-11.2-6.7l2,11.7c0,0,14,18.5,17.9,19.6c1.7,0.5,3,0.2,3.7-0.7 l0,0l0-0.1c1.2-1.3,1.8-5.4,2.2-11.2l0,0c0.3-2.9,0.4-6.2,0.7-9.7C124.6,81.6,124.6,79,124.3,76.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_359",
    className: "st22",
    d: "M116.3,90.8c-0.4,1.1-0.7,2.3-0.9,3.4c-0.4,1.9-0.4,4,0.1,5.9c0,0-1.3-1.5-1.2-4.8 c0-1.9,0.5-3.8,1.3-5.5L116.3,90.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_360",
    className: "st15",
    d: "M60.8,141.1c-0.5-0.7-1.2-1.2-2.1-1.5c-1.7-0.2-3.4,0.6-4.4,2c-1.2,1.9-1.6,4.2-2.3,5.6 c-1.2,1.8-2.5,3.3-4.1,4.7c-1.7,1.9-2.3,4.5-1.8,7c0.5,1.5,1.7,2.6,3.2,3L60.8,141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_361",
    className: "st0",
    d: "M60.1,140.5c-1.7-0.3-3.4,0.4-4.5,1.8c-1.1,1.3-1.7,3.5-2.3,5.1c-0.4,0.8-0.9,1.5-1.5,2.1 c-0.6,0.8-2.3,2.5-2.9,3.3c-0.4,0.7-0.8,1.5-1,2.3c-0.3,0.9-0.4,1.8-0.4,2.7c0.1,1.4,0.7,3.5,1.9,4.3c1.1,0.9,2.8,0.6,3.7-0.5 c0.1-0.2,0.2-0.3,0.3-0.5c0.3-0.5,0.5-1,0.7-1.6c0.5-1,1-2,1.7-2.9c0.9-1.1,1.9-2.2,3.1-3.1c0.1-0.1,0.3-0.2,0.4-0.3 c1.4-0.9,2.9-1.8,3-2.3s0.7-7.3,0.7-7.3C62.3,143.4,61.3,140.9,60.1,140.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_362",
    className: "st19",
    d: "M85.3,113.3l-1.3,41c-0.9-2.1-5.3-3.9-8.9-5.1c-2.3-0.8-6.2-2.9-8.9-3.9l0,0l-4.2-2.2 c-0.9,0.1-1.7,0.5-2.3,1.1c-0.9,0.7-2.4,3.5-1.3,4.3c0.4,0.2,0.6,0.6,0.6,1c0.7-0.4,1.9,0.1,2.6,0.6c0.3,0.2,0.5,0.5,0.6,0.8 c0,0,14.7,9.9,19.5,13.1c6,4,9.3,2.3,11.5-0.6s6.3-13,8.9-21.1s3.2-20.4,3.3-26.1L85.3,113.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_363",
    className: "st15",
    d: "M105.4,116.2l-20.1-2.8c0,0-1.6,28.6-1.5,30.7l0,0c0,1.3,0.5,2.6,1.5,3.5 c3.1,3,7.5,4.4,11.8,3.6c1.9-0.4,3.2-1.4,3.6-2.7l0,0c1.9-5,3.3-10.1,4.2-15.4C105.4,127.5,105.6,121.8,105.4,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_364",
    className: "st16",
    d: "M97.5,125.8l6.6,8.1l-4.9-7.4c0,0,4.4-1.8,5.5-5.4C104.7,121.2,101.5,125.3,97.5,125.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1",
    transform: "matrix(0.6937 -0.7203 0.7203 0.6937 -72.4251 112.95)",
    className: "st16",
    cx: 96.6,
    cy: 141.6,
    rx: 10.5,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_365",
    className: "st15",
    d: "M107.6,203.7c-0.4,0.1-0.4,1.6-0.3,2c0.4,0.8,0.9,1.4,1.6,1.9c1.2,1,2.3,2.2,3.1,3.5 c1,1.7,2.3,3.2,3.9,4.3c2.2,1.3,4.7,1.7,7.2,1.1c2.7-0.5,3-1.8,3-2.8L107.6,203.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_366",
    className: "st0",
    d: "M115.6,198.5c0.4,1,2.5,6.1,5.1,8.2c2.1,1.7,4.9,3.6,5.7,5.6s-2,3.2-5.3,3.2 c-3.4,0-5.1-1.7-6.7-3.5c-1.1-1.2-2.7-3.5-3.5-4.5s-2.6-2-3.1-3.2c-0.2-1.1-0.1-2.2,0.2-3.3c0.3-1.2,0.5-2.4,0.9-2.3l0,0.7 C109.3,199.9,115.6,198.5,115.6,198.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_367",
    className: "st19",
    d: "M111.4,142.7c-6.6-8-13.9-16.9-13.9-16.9l7.9-9.6l-27.9-3.9c-1.2,4.8-2.3,6.5-2.4,12 c0,3.9-0.5,8.5,14.7,20.9c8.4,6.8,14.8,11.4,14.8,11.4s-1.9,3.4-1.8,9.6s5.6,27.1,6,32.6v0.6c0,0.3,0.2,0.4,0.4,0.6 c0.3,0.3,0.5,0.7,0.6,1c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.3,0.1,0.5,0c0.5,0,1.3-0.1,1.5,0.4c0.1-0.5,0.3-1,0.7-1.3 c0.7-0.6,2.9-1.6,3.5-0.1l0,0c-0.6-1.7-0.8-3.5-0.7-5.3c0.2-7.7,0.9-30.8,1-36.6C116.6,152.1,117.4,150,111.4,142.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_368",
    className: "st9",
    d: "M89.5,149.4c-2.2-2.6-0.9-7.4,3.3-11.7c4.1-4.1,10.5-4.5,12.1-2.9l-7.4-9 c2.9,0,6.9-3.4,7.9-6v-3.6l-27.9-4c-1.3,3.3-2.3,6.8-2.8,10.3c-0.5,4.4-0.7,8.9,2.6,13.4S89.5,149.4,89.5,149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_369",
    className: "st16",
    d: "M92,61.8l-2.6,8.9c-7.4,0-11.9-7.2-11.9-14.5l0,0c0-7.4,4.7-13.6,12.1-13.6H92 c7.4,0,13.4,4.9,13.4,12.3l0,0C105.4,59.8,99.4,61.8,92,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_370",
    className: "st16",
    d: "M106.7,48.1c0.6-0.9,0.8-2,0.7-3.1c-0.1-1.1-0.6-2.1-1.5-2.7c-1.5-0.8-3.3-0.6-4.6,0.5 c-0.2-2-2-3.5-4-3.3C96.2,39.8,95,40.3,94,41c-1.8,0.9-3.7,1.5-5.7,1.8l2.2,0.9c-0.6,1-0.8,2.1-0.4,3.2c0.1,0.2,0.2,0.4,0.3,0.6 c3.1,4.6,8.3,7.1,13.8,6.7c0.8,0,1.5-0.2,2.1-0.6c0.4-0.3,0.7-0.6,0.9-1c0.5-0.7,0.7-1.5,0.7-2.4 C107.9,49.3,107.5,48.5,106.7,48.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_371",
    className: "st0",
    d: "M85.1,74.3h-1.4c-6.5,0.5-6.9,2.7-7.2,5.6c-0.6,3.1-0.5,6.2,0.2,9.2c1,4,3,13.6,3,13.6 s-2.6,8.5-3.4,12.7c11.4,7.4,24.4,5.2,29.1,0.7c-0.1-4,0.1-8.4-0.2-12.2c0.1-3,0.3-6,0.7-9c3.1-3.9,2.8-6.9,1.5-10.1 c-2.3-5.6-8-10.4-9.5-10.4L85.1,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_372",
    className: "st19",
    d: "M100.6,48.6c1.5,0.9,3.4,4.8,3.3,12.9c-0.2,6.9-2.4,8.6-3.5,9.1s-3.3,0.2-5.4-0.2v4.1 c0,0,2.9,3.4,2.7,5.3s-4.2,2.3-6.9,0.5c-1.9-1.5-3.4-3.4-4.4-5.5v-8.9c0,0-1.4,1.7-3.7,0.1s-2.4-5.4-1.1-6.7s4.3-0.9,4.8,1 c2.8-0.1,5.4-0.9,7.8-2.3C97.7,56,100,52.5,100.6,48.6L100.6,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_373",
    className: "st16",
    d: "M95.4,59.7c0,0.5-0.3,0.9-0.8,0.9c0,0,0,0,0,0c-0.5,0-0.9-0.4-0.9-0.9 c0-0.5,0.4-0.9,0.9-0.9C95,58.9,95.3,59.3,95.4,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_374",
    className: "st22",
    d: "M96.4,65.6l2,0.6c-0.1,0.6-0.7,0.9-1.3,0.8c0,0,0,0,0,0C96.5,66.8,96.2,66.2,96.4,65.6 C96.4,65.6,96.4,65.6,96.4,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_375",
    className: "st16",
    d: "M102.5,57.1l-1.8-1.2c0.3-0.5,0.9-0.6,1.4-0.4c0,0,0.1,0,0.1,0.1 C102.7,55.9,102.8,56.6,102.5,57.1L102.5,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_376",
    className: "st16",
    d: "M102.1,59.1c0,0.5-0.4,0.9-0.9,0.8s-0.9-0.4-0.8-0.9s0.4-0.9,0.9-0.8c0.1,0,0.3,0,0.4,0.1 C101.9,58.5,102.1,58.8,102.1,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_377",
    className: "st22",
    d: "M97.8,58.6l0.1,5.2l2.7-0.9L97.8,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_378",
    className: "st22",
    d: "M94.9,70.4c-2.2-0.3-6.8-1.6-7.5-3.4c0.3,0.9,0.8,1.7,1.6,2.3c1.4,1.2,5.9,2.5,5.9,2.5 L94.9,70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_379",
    className: "st19",
    d: "M64.9,123.8c-0.8-1.9-1.4-2.5-1.8-4.3c0.5,0.5,1.1,1,1.7,1.4c0.7,0.4,1.8,0.4,2.1-0.3 s-0.9-1.1-1.4-1.9c-0.7-1.4-1.5-2.7-2.4-3.9c-0.5-0.5-0.8-1.2-0.8-1.9c0.1-5.1,0.8-10.6,1-15.9c3.7-2.7,10-5.6,13.4-7.8 c2.1-0.3,4-1.4,5.4-3c1.8-2.2,2.5-5.1,2.1-7.9c-0.2-1.2-0.7-3.4-2-3.7c-1.5-0.1-3,0.2-4.4,0.9c-3.7,1.8-7.3,3.8-10.7,6.1 c-4.5,2.7-8.6,6.1-12.1,10c-1.6,1.8-0.6,16.7-0.3,20.2c0.1,1.9,0.4,4.8,0.8,7.4c0.7,4.2,3.1,7.8,6.2,8.5 C66.5,128.7,66,126.4,64.9,123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_380",
    className: "st21",
    d: "M86.3,103c0,0,11.5,0.7,18.4-2.9v11.5c-5.7,3.1-12.4,3.9-18.7,2.2L86.3,103z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_381",
    d: "M92.4,108.1v1.5c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.2,0.5-0.4,0.7c-0.2,0.2-0.4,0.4-0.7,0.5 c-0.3,0.1-0.7,0.2-1,0.1c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.5-0.3-0.7-0.5c-0.2-0.2-0.3-0.5-0.4-0.7c-0.1-0.3-0.1-0.6-0.1-0.9v-0.7 c0-0.2,0-0.5,0-0.7c0-0.3,0.1-0.6,0.2-0.9c0.2-0.5,0.6-1,1.1-1.1c0.3-0.1,0.7-0.1,1.1-0.1c0.4,0,0.7,0.1,1,0.2 c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.5,0.4,0.7C92.4,107.6,92.4,107.9,92.4,108.1z M89,109.5c0,0.3,0.1,0.7,0.3,1 c0.2,0.3,0.5,0.4,0.8,0.4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.3,0.3-0.6,0.3-0.9c0-0.2,0-0.5,0-0.7c0-0.2,0-0.5,0-0.7 c0-0.3-0.1-0.7-0.3-0.9c-0.5-0.4-1.2-0.5-1.7-0.1c-0.2,0.3-0.3,0.6-0.3,0.9c0,0.2,0,0.5,0,0.7C89,109,89,109.2,89,109.5L89,109.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_382",
    d: "M96.5,107.9c0.1-0.1,0.3-0.3,0.3-0.5c0-0.1,0.1-0.3,0.1-0.4c0-0.2-0.1-0.4-0.2-0.5 c-0.2-0.1-0.5-0.2-0.7-0.1c-0.3,0-0.5,0.2-0.7,0.3c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1l-0.7,0.1 c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.2c0-0.3,0.1-0.5,0.2-0.7c0.1-0.2,0.3-0.5,0.5-0.7c0.2-0.2,0.4-0.4,0.7-0.5 c0.3-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.6-0.1,0.9,0c0.2,0.1,0.5,0.2,0.6,0.3c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.1,0.4,0.1,0.6 c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.2-0.3,0.4-0.5,0.5l-1.6,1.7c0.9-0.2,1.4-0.3,2.4-0.5 c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1v0.6c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1c-1.6,0.3-2.4,0.5-4,0.7c-0.1,0-0.1,0-0.2,0 c0,0-0.1-0.1-0.1-0.1V111c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2C94.9,109.5,95.4,109,96.5,107.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_383",
    d: "M103.5,103.6c0,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1v0.6c0,0.1,0,0.1-0.1,0.2l-0.1,0.2l-1.3,1.7 c0.2,0,0.5,0,0.7,0c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.3,0.2,0.3,0.4c0.1,0.2,0.1,0.4,0.1,0.6c0,0.3-0.1,0.6-0.2,0.8 c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.4-0.7,0.6c-0.3,0.2-0.6,0.3-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.3,0-0.5-0.1-0.7-0.2 c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.2-0.1-0.3-0.2-0.5c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.1l0.7-0.2c0,0,0.1,0,0.1,0 c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0,0.2,0,0.4,0c0.2,0,0.3-0.1,0.5-0.1c0.3-0.1,0.6-0.2,0.8-0.4 c0.2-0.2,0.3-0.4,0.3-0.7c0-0.2-0.1-0.4-0.3-0.5c-0.3,0-0.6,0-0.8,0.1l-0.7,0.2c-0.1,0-0.2,0-0.2-0.1c0,0,0,0,0-0.1v-0.6 c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2l1.2-1.6c-0.9,0.3-1.4,0.4-2.3,0.6c0,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.1v-0.6 c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1C101.3,104.3,102.1,104.1,103.5,103.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hurdle-1--inject-209",
    transform: "translate(97.714 208.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--fence--inject-209-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_384",
    className: "st9",
    d: "M68.8,96v56.6c0,0.2-0.2,0.4-0.4,0.4c-0.1,0-0.1,0-0.2-0.1L49,141.8l-2.5,4.3l22.4,13 c1.5,0.9,3.4,0.4,4.3-1.1c0.3-0.5,0.4-1,0.4-1.6V98.8L68.8,96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_385",
    className: "st9",
    d: "M47.8,142c1-0.6,1.8-0.1,1.8,1c-0.1,1.2-0.7,2.4-1.8,3c-1,0.6-1.7,0.1-1.7-1 C46.1,143.8,46.8,142.6,47.8,142z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_386",
    className: "st9",
    d: "M136.9,56.7v56.6c0,0.2-0.2,0.4-0.4,0.4c-0.1,0-0.1,0-0.2-0.1l-19.2-11.1l-2.5,4.3l22.5,13 c1.5,0.9,3.4,0.4,4.3-1.1c0.3-0.5,0.4-1,0.4-1.6V59.5L136.9,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_387",
    className: "st9",
    d: "M115.9,102.7c1-0.6,1.8-0.1,1.8,1c-0.1,1.2-0.7,2.4-1.8,3c-1,0.6-1.7,0.1-1.7-1 C114.2,104.5,114.9,103.3,115.9,102.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_388",
    className: "st0",
    d: "M58.9,87.4l82.9-47.9l4.9,2.9v17.1l-82.9,47.9l-4.9-2.9V87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_389",
    className: "st10",
    d: "M58.9,87.4l4.9,2.8l82.9-47.9l-4.9-2.9L58.9,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_390",
    className: "st11",
    d: "M63.9,90.3l82.9-47.9v17.1l-82.9,47.9V90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_391",
    className: "st12",
    d: "M58.9,87.4l4.9,2.8v17.1l-4.9-2.9V87.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuasela);
export default __webpack_public_path__ + "static/media/Quasela.c6eb84bec8fa6d1a9aa3ff632e206df7.svg";
export { ForwardRef as ReactComponent };